
import "./Playerstatistics.css";
// import ffc from "../../teamImage/ffc.png";
// import manU from "../../teamImage/manU.png";
// import she from "../../teamImage/she.png";
import kelvin from "../../teamImage/kelvin.jpg";
import backArrow from "../../../../images/arrow.png";
      import whiteArrow from "../../../../images/white-arrow.png";
import { NavLink } from "react-router-dom";

const Playerstatistics = ({dark}) => {



    const stats = [ 
        {item: "Goal per minute", score: 3215},  {item: "Yellow card", score: 0}, 
        {item: "Red card", score: 0},  {item: "Penalty goals", score: 0}, 
        {item: "Penalty missed", score: 0},  {item: "Shots on target", score: 0}, 
        {item: "Offside", score: 0},  {item: "Corners", score: 0}, 
        {item: "Crosses", score: 0},  {item: "Tackles", score: 0}, 
        {item: "Foul committed", score: 0},  {item: "Foul suffered", score: 0}, 
        {item: "Freekick goals", score: 0},  {item: "Goal outside box", score: 0}, 
        {item: "Hit woodwork", score: 0}
    ]
    return <div className="playerdetailWrapper" style={dark ? {backgroundColor: "#111111e7"} : {}}>
        
      <NavLink className="strong" to="/teams/details" style={{ cursor: "pointer" }}>
        ←
      </NavLink>
        
        <section className="firstsection">
            <nav>
                <img src={kelvin} alt="" />
                <div>
                    <p style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>Kelvin Williams</p>
                    <strong style={dark ? {color: "#e2e1e1ff"} : {color: "#3F3E3E"}}>22 years,  England</strong>
                    <strong style={dark ? {color: "#e2e1e1ff"} : {color: "#3F3E3E"}}>Manchester city</strong>
                </div>
            </nav>
            <menu>
                <ul style={dark ? {backgroundColor: "#131313ff"} : {}}>
                    <li><NavLink to="/teams/players" className="linkname"
                     style={dark ? {color: "#fafafaff"} : {color: "#3F3E3E"}}>Overview</NavLink></li>
                    <li><NavLink to="/teams/player/news" className="linkname"
                     style={dark ? {color: "#fafafaff"} : {color: "#3F3E3E"}}>News</NavLink></li>
                    <li><NavLink to="/teams/player/statistics" className="linkname"
                     style={dark ? {color: "#fafafaff"} : {}}>Statistics</NavLink></li>
                </ul>
            </menu>
        </section>

        <section className="seventhsection">
            <div>
                <select name="competition" id="" style={dark ? {backgroundColor: "#1f1f1fff", border: "1px solid #202020ff", color: "white"} : {}}>
                    <option value="All competition">All competition</option>
                    <option value="All competition">All competition</option>
                    <option value="All competition">All competition</option>
                    <option value="All competition">All competition</option>
                    <option value="All competition">All competition</option>
                    <option value="All competition">All competition</option>
                </select>

                <input type="date" style={dark ? {backgroundColor: "#1f1f1fff", border: "1px solid #202020ff", color: "white"} : {}} />
            </div>

            <div className="cards">
                <nav style={{backgroundColor: "#B1A230"}}>
                    <h2>30</h2>
                    <strong>Appearance</strong>
                </nav>
                
                <nav style={{backgroundColor: "#8B1F0C"}}>
                    <h2>20</h2>
                    <strong>Goals</strong>
                </nav>
                
                <nav style={{backgroundColor: "#304EB1"}}>
                    <h2>10</h2>
                    <strong>Assist</strong>
                </nav>
                
                <nav style={{backgroundColor: "#B1304C"}}>
                    <h2>2700</h2>
                    <strong>minutes played</strong>
                </nav>
            </div>

            <h1 style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>More season stats</h1>

            <div>
                <table style={dark ? {backgroundColor: "#1f1f1fff"} : {}}>
                    <tr>
                        <th style={dark ? {color: "#fafafaff"} : {color: "#161819"}}></th>
                        <th style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>Total</th>
                    </tr>
                    {
                        stats.map((mystat, index) => (
                            <tr>
                                <th style={dark ? {color: "#fafafaff"} : {color: "#161819e3"}}>{mystat.item}</th>
                                <th style={dark ? {color: "#fafafaff"} : {color: "#161819e3"}}>{mystat.score}</th>
                            </tr>
                        ))
                    }
                </table>
            </div>
        </section>


    </div>
}

export default  Playerstatistics;